export class LocationList {

   name: string;
   desc: string;

  constructor()
      { }
}
